import { SHADOW_BACKGROUND_LEVEL_2_LIGHT, SHADOW_BACKGROUND_LEVEL_3_LIGHT, SHADOW_BACKGROUND_CARD_LIGHT, } from "@audi/audi-ui-design-tokens";
export const shadow = {
    background: {
        level: {
            2: SHADOW_BACKGROUND_LEVEL_2_LIGHT,
            3: SHADOW_BACKGROUND_LEVEL_3_LIGHT,
        },
        card: SHADOW_BACKGROUND_CARD_LIGHT,
    },
};
//# sourceMappingURL=audi-shadows.mjs.mjs.map